import { Button, Stack, Typography } from '@mui/material';
import { AtLocator } from '@Components/shared/locators/AtLocator';
import { useCampaignsTable } from '@Modal/hooks/campaigns/useCampaignsTable';
import { useCreateCampaign } from '@Modal/hooks/campaigns/useCreateCampaign';
import { useAuthorization } from '@Modal/hooks/authorization/useAuthorization';

export const CampaignsTitle: React.FC = () => {
  const { campaignTableFilters, handleClearCampaignTableFilters } = useCampaignsTable();
  const { handleOpenCreateCampaignModal } = useCreateCampaign();
  const objectVals = Object.values(campaignTableFilters);
  const disabled = objectVals.length === 0 || objectVals.every((val) => val === undefined);
  const { userPermissions, currentUser } = useAuthorization();
  const permissionToCreateCampaigns =
    userPermissions?.includes('CAN_MANAGE_FREEBETS_CAMPAIGNS') || currentUser?.isSuper;

  return (
    <AtLocator type="container" name="CampaignsTitle">
      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        sx={{ padding: '4px 0' }}
      >
        <Stack direction="row" alignItems="center" justifyContent="space-between">
          <Typography variant="h3">Campaigns</Typography>
        </Stack>
        <Stack direction="row" gap="4px">
          {permissionToCreateCampaigns && (
            <Button variant="contained" size="large" onClick={handleOpenCreateCampaignModal}>
              Create Campaign
            </Button>
          )}
          <AtLocator type="button" name="clearFilters">
            <Button
              size="large"
              variant="contained"
              disabled={disabled}
              onClick={handleClearCampaignTableFilters}
            >
              Clear filters
            </Button>
          </AtLocator>
        </Stack>
      </Stack>
    </AtLocator>
  );
};
